module.exports = "/images/Italy.png?9cf02e6ffa416359ebf6dba6f6c880bc";